import { render } from "./Fleet.vue?vue&type=template&id=48d5d689&scoped=true"
import script from "./Fleet.vue?vue&type=script&lang=js"
export * from "./Fleet.vue?vue&type=script&lang=js"

import "./Fleet.vue?vue&type=style&index=0&id=48d5d689&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d5d689"]])

export default __exports__